type DueDiligenceTarget = {
  id: string;
  property?: {
    id?: string | null;
    active_matter_id?: string | null;
    active_deal_id?: string | null;
  } | null;
};

export function getDueDiligenceStartPath(target: DueDiligenceTarget) {
  const activeMatterId = target.property?.active_matter_id;
  if (activeMatterId) {
    return `/matters/${activeMatterId}`;
  }

  const activeDealId = target.property?.active_deal_id;
  if (activeDealId) {
    return `/deal-intake/${activeDealId}`;
  }

  const propertyId = target.property?.id;
  return propertyId ? `/due-diligence?property=${propertyId}` : "/due-diligence";
}
